<template>
  <div class="w-full border-b border-gainsboro" />
</template>

<script>
  export default {
    name: 'Divider',
  };
</script>
